import EventEmitterBase from '../utils/event-emitter';
import isUndefined from './utils/is-undefined';

function prepareEvent (event) {
  if (typeof event === 'string') {
    event = { type: event };
  }

  if (isUndefined(event.preventDefault)) {
    let _defaultPrevented = false;
    Object.defineProperties(event, {
      defaultPrevented: {
        get () {
          return _defaultPrevented;
        }
      },
      preventDefault: {
        value: function () {
          _defaultPrevented = true;
        }
      }
    });
  }

  return event;
}

export default class EventEmitter extends EventEmitterBase {
  constructor () {
    super();
    this._observers = [];
    this._asyncEventQueue = [];
    this._asyncEventQueueTimeout = null;
  }

  /**
   * Triggers event listeners for an event
   *
   * @param {object|string} event The type of event to fire or an actual event object to fire
   *
   * @return {object}
   */
  emit (event) {
    event = prepareEvent(event);

    super.emit(event);

    const observers = this._observers || [];
    for (let i = 0, len = observers.length; i < len; i++) {
      observers[i](event);
    }

    return event;
  }

  /**
   * Triggers event listeners for an event asynchronously
   *
   * @param {object|string} event The type of event to fire or an actual event object to fire
   *
   * @return {object}
   */
  emitAsync (event) {
    event = prepareEvent(event);

    setTimeout(_ => { this.emit(event); }, 0);

    return event;
  }

  /**
   * Adds a callback to the observers list
   *
   * @param {function} callback
   */
  observe (callback) {
    this._observers.push(callback);
  }

  /**
   * Removes an callback from the observers list
   *
   * @param {function} callback
   */
  unobserve (callback) {
    const idx = this._observers.indexOf(callback);

    if (idx !== -1) {
      this._observers.splice(idx, 1);
    }
  }
}
